import React from 'react'
// import moment from 'moment'
import { DateUtil, TIME } from '@utils'
import { InputGroup, TextArea, Position, Intent, FormGroup } from '@blueprintjs/core'
import { DateInput2 } from '@blueprintjs/datetime2'
import { LocationSelect, EmployeeSelect } from '@ui'
import StatusSelect, { getTicketStatus } from './StatusSelect'
import PrioritySelect from './PrioritySelect'
import { TicketFormErrors } from './TicketForm'
import { FormTicket } from '@api/ticket/create'
import { IBuildingDetails, IFloorDetails } from '@api'

interface IRow {
  label?: string
  required?: boolean
  formEl: (
    ticket: FormTicket,
    update: (key: keyof FormTicket, value: any) => void,
    errors: TicketFormErrors
  ) => React.ReactNode
}

export const rows: IRow[] = [
  {
    label: 'Title',
    required: true,
    formEl: (ticket, update, errors) => (
      <FormGroup
        helperText={errors.shortDescription}
        intent={errors.shortDescription ? Intent.DANGER : undefined}>
        <InputGroup
          intent={errors.shortDescription ? Intent.DANGER : undefined}
          autoFocus
          data-input="title"
          value={ticket.shortDescription}
          onChange={(e: any) => update('shortDescription', e.target.value)}
        />
      </FormGroup>
    ),
  },
  {
    label: 'Description',
    required: true,
    formEl: (ticket, update, errors) => (
      <FormGroup
        helperText={errors.description}
        intent={errors.description ? Intent.DANGER : undefined}
        style={{ marginBottom: 20 }}>
        <TextArea
          rows={5}
          style={{ width: '100%' }}
          intent={errors.description ? Intent.DANGER : undefined}
          value={ticket.description}
          onChange={(e: any) => update('description', e.target.value)}
        />
      </FormGroup>
    ),
  },
  {
    label: 'Status',
    required: true,
    formEl: (ticket, update, errors) => (
      <FormGroup helperText={errors.status} intent={errors.status ? Intent.DANGER : undefined}>
        <StatusSelect
          buttonProps={{ 'data-button': 'status_select' }}
          value={getTicketStatus(ticket.status)}
          onChange={(status) => {
            if (status) {
              update('status', status.value)
            }
          }}
        />
      </FormGroup>
    ),
  },
  {
    label: 'Priority',
    required: true,
    formEl: (ticket, update, errors) => (
      <FormGroup helperText={errors.severity} intent={errors.severity ? Intent.DANGER : undefined}>
        <PrioritySelect
          buttonProps={{ 'data-button': 'priority_select' }}
          value={ticket.severity}
          onChange={(severity) => update('severity', severity)}
        />
      </FormGroup>
    ),
  },

  {
    label: 'Assigned to',
    formEl: (ticket, update, errors) => (
      <FormGroup
        helperText={errors.assignedTo}
        intent={errors.assignedTo ? Intent.DANGER : undefined}>
        <EmployeeSelect
          clearable
          value={ticket.assignedTo}
          onChange={(employee) => update('assignedTo', employee)}
        />
      </FormGroup>
    ),
  },
  {
    label: 'Location',
    formEl: (ticket, update, errors) => (
      <FormGroup
        helperText={errors.building || errors.floor_plan}
        intent={errors.building || errors.floor_plan ? Intent.DANGER : undefined}>
        <LocationSelect
          includeOldBuildings
          clearable
          mode={LocationSelect.Mode.SINGLE_BUILDING_FLOOR}
          value={ticket.floor_plan?.id || ticket.building?.id || null}
          onChange={(option?: IBuildingDetails | IFloorDetails) => {
            if (option) {
              if ('building' in option) {
                update('building', option.building)
                update('floor_plan', { id: option.id, name: option.name })
                return
              }
              update('building', option)
              update('floor_plan', null)
            } else {
              update('building', null)
              update('floor_plan', null)
            }
          }}
        />
      </FormGroup>
    ),
  },
  {
    label: 'Due date',
    formEl: (ticket, update, errors) => (
      <FormGroup helperText={errors.dueDate} intent={errors.dueDate ? Intent.DANGER : undefined}>
        <DateInput2
          popoverProps={{
            minimal: true,
            position: Position.BOTTOM,
            modifiers: { arrow: { enabled: false } },
          }}
          value={ticket.dueDate ? DateUtil(ticket.dueDate).toString() : null}
          formatDate={(date) => DateUtil(date).format('MM/dd/yyyy')}
          parseDate={(dateStr) => DateUtil(dateStr, 'MM/dd/yyyy').toDate()}
          maxDate={DateUtil().add(7, TIME.YEARS).toDate()}
          placeholder={'MM/DD/YYYY'}
          onChange={(date) =>
            date ? update('dueDate', DateUtil(date).format('yyyy-MM-dd')) : update('dueDate', null)
          }
        />
      </FormGroup>
    ),
  },
]
